
export class BankWithFinancialGuarantee {
    availableCommitment: number;
    financialGuaranteeAvailableCommitment: number;
    financialGuaranteeRate: number;
    rate: number;
}
